import styled from 'styled-components';

export const StyledToolbarWrapper = styled.div`
  display: grid;
  grid-template-columns: ${({open}) => open ? '1fr' : '58px 1fr'};
`;

export const StyledToolbarContent = styled.div`
  height: 80px;
  padding: 0 20px;
  display: grid;
  grid-template-columns: 55px 145px auto;
  grid-gap: 20px;
  align-items: center;
  justify-content: end;
  .toolbar-search {
    &__text {
    & > div {
        input {
            background: rgba(255 255 255 / 0.25) !important;
          &:focus {
            background: rgba(255 255 255 / 1) !important;
          }
        }
      }
    }
    @media screen and (max-width: 599px) {
      display: none;
    }
  }
  @media screen and (max-width: 1200px) {
    grid-gap: 25px;
  }
  @media screen and (max-width: 992px) {
    padding: 0 15px;
  }
  @media screen and (max-width: 599px) {
    height: 60px;
    grid-template-columns: repeat(2, 35px) auto;
    grid-gap: 12px;
  }
`;

export const StyledToolbarButton = styled.button`
  height: 40px;
  width: 40px;
  color: ${({theme}) => theme.header.buttonColor};
  font-size: 16px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: ${({theme}) => theme.header.buttonBackground};
  border: none;
  border-radius: 50%;
  outline: none;
  transition: all .1s ease;
  &:hover {
    background: ${({theme}) => theme.header.buttonHoverBackground};
    color: ${({theme}) => theme.header.buttonColor} !important;
  }
  
  @media screen and (max-width: 600px) {
    width: 35px;
    height: 35px;
    font-size: 14px;
    
    &:not(:nth-child(2)) {
      display: none;
    }
  }
`;

export const StyledToolbarButtonWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 12px;
  
  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const StyledToolbarUserInfo = styled.div`
  display: grid;
  grid-template-columns: 48px auto 35px;
  grid-gap: 15px;
  align-items: center;
  @media screen and (max-width: 768px) {
    grid-template-columns: 48px 35px;
    justify-content: end;
  }
  @media screen and (max-width: 599px) {
    grid-template-columns: repeat(2, 35px);
    grid-gap: 5px;
  }
`;

export const StyledUserPhoto = styled.div`
  height: 48px;
  width: 48px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: ${({theme}) => theme.header.userPhotoBackground};
  border-radius: 50%;
  box-shadow: 0 7px 14px ${({theme}) => theme.header.userPhotoShadow};
  overflow: hidden;
  .user-photo {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    border-radius: 50%;
  }
  span {
    color: ${({theme}) => theme.header.userInitialColor};
    font-size: 21px;
    font-weight: 700;
    text-align: center;
    text-transform: capitalize;
  }
  @media screen and (max-width: 599px) {
    height: 35px;
    width: 35px;
    box-shadow: 0 3px 7px ${({theme}) => theme.header.userPhotoShadowMobile};
    span {
      font-size: 18px;
    }
  }
`;

export const StyledUserDescription = styled.div`
  max-width: 200px;

  @media screen and (max-width: 992px) {
    text-align: left;
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const StyledUserName = styled.div`
  max-width: 200px;
  color: ${({theme}) => theme.header.userNameColor};
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  text-transform: lowercase;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  @media screen and (max-width: 992px) {
    text-align: left;
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const StyledUserRole = styled.div`
  max-width: 200px;
  color: ${({theme}) => theme.header.userRoleColor};
  font-size: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const StyledDropdownBtn = styled.button`
  width: 35px;
  height: 35px;
  color: ${({theme}) => theme.header.dropdownButtonIdleColor};
  background-color: transparent;
  border: none;
  outline: none;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  &:hover {
    color: ${({theme}) => theme.header.dropdownButtonColor};
    background-color: ${({theme}) => theme.header.dropdownButtonHoverBackground};
  }
`;

export const StyledDropdownItem = styled.button`
  width: 100%;
  color: ${({theme}) => theme.header.dropdownItemColor};
  display: grid;
  grid-template-columns: 25px 1fr;
  grid-gap: 10px;
  text-align: left;
  background-color: transparent;
  border: none;
  outline: none;  
  cursor: pointer;
  span {
    color: ${({theme}) => theme.header.dropdownIconColor};
    font-size: 18px;
  }
`;

export const StyledSidebarBtn = styled.button`
  width: 100%;
  color: ${({theme}) => theme.header.burgerColor};
  display: ${({open}) => open ? 'none' : 'inline-flex'};
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  border: none;
  outline: none;
  transition: all .3s ease;
  .toolbar-logo__drawer-icon {
    width: 45px;
    padding-bottom: 5px;
    filter: ${({theme}) => theme.brand.logoFilter};
  }
  &:before {
    content: '\\e922';
    height: 15px;
    width: 15px;
    margin-top: -7px;
    font-family: 'cp-icons', serif;
    position: absolute;
    top: 50%;
    right: 0;
    @media screen and (max-width: 599px) {
      content: '\\e917';
      height: 18px;
      width: 18px;
      margin-top: -9px;
      color: ${({theme}) => theme.header.burgerMobileColor};
      font-size: 18px;
      right: -10px;
    }
  }
  &:hover {
   transform: scale(1.05);
  }
  @media screen and (max-width: 992px) {
    .toolbar-logo__drawer-icon {
      width: 30px;
    }
  }
  @media screen and (max-width: 960px) {
    width: 58px;
  }
`;